import { Dropdown } from 'react-bootstrap';

interface OrderStatusFilterProps {
  status: string;
  onStatusChange: (value: string) => void;
}

export function OrderStatusFilter({ status, onStatusChange }: OrderStatusFilterProps) {
  const statuses = ['Select Status', 'Processing', 'Shipped', 'Completed', 'Cancelled', 'Refunded', 'Failed'];

  return (
    <div className="flex items-center gap-2">
      <Dropdown className="w-full">
        <Dropdown.Toggle
          variant="outline-dark"
          className="cursor-pointer"
          style={{
            width: '160px',
            color: status && status !== 'Select Status' ? '#EE6767' : undefined,
          }}
        >
          {status || 'Status'}
        </Dropdown.Toggle>
        <Dropdown.Menu className="p-2 max-h-96 overflow-y-auto" style={{ width: '180px' }}>
          {statuses.map((s) => (
            <Dropdown.Item
              className="cursor-pointer"
              key={s}
              onClick={() => onStatusChange(s)}
              active={s === status}
              style={s === status && s !== 'Select Status' ? { color: '#EE6767' } : {}}
            >
              {s}
            </Dropdown.Item>
          ))}
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
}
